// TOP - mv メインビジュアル
var mySwiper = new Swiper('.js-slider--main', {
	slidesPerView: 1,
	spaceBetween: 0,
	loop: true,
	effect: 'fade',
	speed: 2000, // フェードの遷移をゆっくりにする（ミリ秒単位）
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
	autoplay: {
		delay: 3000,
	},
})

var mySwiper = new Swiper('.c-slider--gallery__container', {
	loop: true,
	effect: 'slide',
	speed: 2000,
	autoplay: {
		delay: 4000,
	},
	breakpoints: {
		767: {
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 500,
		},
		// ウィンドウサイズが640px以下
		1920: {
			slidesPerView: 2.5,
			spaceBetween: 20

		}
	}
})
